import React from "react";
import { motion } from "framer-motion";

const AdminPageHeader = ({
  title,
  subtitle,
  icon,
  actionLabel,
  onAction,
  badge,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6"
    >
      <div className="flex items-start gap-4">
        {icon && (
          <div className="hidden sm:flex w-14 h-14 rounded-2xl bg-gradient-to-br from-brand-500 to-eco-500 items-center justify-center text-white shadow-lg shadow-brand-500/30">
            {icon}
          </div>
        )}
        <div>
          <div className="flex items-center gap-2 flex-wrap">
            <h1 className="font-oswald text-2xl sm:text-3xl font-semibold text-slate-900">
              {title}
            </h1>
            {badge != null && (
              <span className="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-brand-100 text-brand-700">
                {badge}
              </span>
            )}
          </div>
          {subtitle && (
            <p className="text-sm text-slate-500 font-overpass mt-1">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-brand-600 to-eco-600 text-white font-semibold text-sm shadow-lg shadow-brand-500/30 hover:shadow-brand-500/50 transition-all hover:-translate-y-0.5"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          {actionLabel}
        </button>
      )}
    </motion.div>
  );
};

export default AdminPageHeader;
